export const TITLEBAR_SET_VARS = 'TITLEBAR_SET_VARS';

export function setTitleBarVars(values) {
	return {
		type: TITLEBAR_SET_VARS,
		values
	};
}